import React from 'react'
import { Link } from 'react-router-dom'

const ProductFlow = () => {
    return (
        <>
            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Product Flow</h1>

                    </div>
                </div>
            </div>
            <div className='container pb-2'>
            <ul className='learning-outcomes p-3 '> 
                    <li><Link to='http://[::1]/ittcouncil/website/OnlineCourses'> Online Course</Link></li>
                    <li>Course -(Select <Link to='http://[::1]/ittcouncil/website/OnlineCourses'>Online Course</Link>)</li>
                    <li>Apply - (Click On Apply)</li>
                    <li>Admission Registration Form (Fillup registration form)</li>
                    <li>Payment Proccess - (Pay course fees via payment gateway)</li>
                    <li>After payment you will received ,your admission will be activate</li>
                    <li>You will received detail email,call by ittcouncil</li>
                </ul>
            </div>

        </>
    )
}

export default ProductFlow